import { SVGPropsIcon } from 'src/types';

export const LogOutIcon = (props: SVGPropsIcon) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M13.3528 11.6948C12.9928 12.0369 12.5049 12.2296 11.9958 12.2307C11.486 12.2318 10.9965 12.0406 10.6348 11.6991C10.2731 11.3576 10.0687 10.8936 10.0664 10.4091V1.82972C10.0664 1.34445 10.2692 0.879052 10.6303 0.535913C10.9913 0.192774 11.481 0 11.9915 0C12.5021 0 12.9918 0.192774 13.3528 0.535913C13.7139 0.879052 13.9167 1.34445 13.9167 1.82972V10.405C13.9156 10.8889 13.7128 11.3526 13.3528 11.6948Z"
      fill={props.fill ? props.fill : 'white'}
    />
    <path
      d="M4.50334 2.62981C5.28565 2.00392 6.4061 2.31106 6.90703 3.17871C7.40797 4.04636 7.09281 5.14347 6.35316 5.81924C5.4529 6.64175 4.73762 7.65615 4.26538 8.79621C3.56012 10.4989 3.43639 12.3867 3.91338 14.1668C4.39036 15.9469 5.44142 17.52 6.90352 18.6419C8.36562 19.7638 10.1571 20.3719 12 20.3719C13.8429 20.3719 15.6344 19.7638 17.0965 18.6419C18.5586 17.52 19.6096 15.9469 20.0866 14.1668C20.5636 12.3867 20.4399 10.4989 19.7346 8.79622C19.2624 7.65615 18.5471 6.64175 17.6469 5.81924C16.9072 5.14347 16.592 4.04636 17.093 3.17871C17.5939 2.31106 18.7144 2.00392 19.4967 2.62981C21.0695 3.88817 22.3083 5.52893 23.0866 7.4078C24.0975 9.84833 24.2748 12.5542 23.5911 15.1058C22.9074 17.6574 21.4009 19.9121 19.3051 21.5202C17.2094 23.1284 14.6416 24 12 24C9.35839 24 6.7906 23.1283 4.69487 21.5202C2.59914 19.9121 1.09259 17.6574 0.408894 15.1058C-0.274805 12.5542 -0.0974505 9.84833 0.91345 7.4078C1.69171 5.52892 2.93051 3.88817 4.50334 2.62981Z"
      fill={props.fill ? props.fill : 'white'}
    />
  </svg>
);
